import { Component, output, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FullscreenLayoutAreas, FullscreenLayoutTemplate, layoutTemplatesAreas } from '@src/assets/css/fullscreen.template.scss';

@Component({
    selector: 'st-sidecar-selector',
    imports: [MatButtonModule, MatIconModule],
    templateUrl: './sidecar-selector.html',
    styleUrl: './sidecar-selector.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'sidecar-selector',
    },
})
export class SidecarSelectorComponent {
    readonly layoutSelected = output<{ layout: FullscreenLayoutTemplate; sidecar: FullscreenLayoutAreas }>();

    availableTemplates = (Object.entries(layoutTemplatesAreas) as [FullscreenLayoutTemplate, Set<FullscreenLayoutAreas>][]).reduce(
        (acc, [layout, areas]) => {
            const items = Array.from(areas)
                ?.filter(area => area !== FullscreenLayoutAreas.MAIN)
                ?.map(area => {
                    const id = `${layout}_${area}`;
                    return { id, sidecar: area, layout };
                });
            if (items && items.length > 0) {
                acc.push(...items);
            }
            return acc;
        },
        [] as { id: string; sidecar: FullscreenLayoutAreas; layout: FullscreenLayoutTemplate; icon?: string }[]
    );

    selectSidecar(layout: FullscreenLayoutTemplate, sidecar: FullscreenLayoutAreas): void {
        this.layoutSelected.emit({ layout, sidecar });
    }
}
